import { createI18n } from "vue-i18n";
import { locales } from "@socotec.io/socio-vue-components";
import { purgeMessages } from "@/locales/intervention/purgeMessages";
import { sampleMessages } from "@/locales/intervention/sampleMessages";
import { materialMessages } from "@/locales/material/materialMessages";
import { surveyMessages } from "@/locales/survey/surveyMessages";
import { inverstigatedEnvsMessages } from "@/locales/intervention/inverstigatedEnvsMessages";
import { lithologyMessages } from "@/locales/intervention/lithologyMessages";
import { environmentMessages } from "@/locales/investigation";
import { vulnerabilityMessages } from "@/locales/site/vulnerabilityMessage";
import { conclusionMessages } from "@/locales/site/conclusionMessage";
import { messages as siteMessages } from "@/locales/site/siteMessage";
import { reportsMessages } from "@/locales/intervention/reportsMessages";
import { programMessages } from "@/locales/schema-program/programMessages";
import { messages as schemaMessages } from "@/locales/schema-program/schema";
import { localesMessages } from "@/locales/messages";
import { supervisionMessages } from "@/locales/supervision/supervisionMessages";
import { globalEnv } from "@/constants";
const messages = {
  en: {
    $vuetify: locales.en.$vuetify,
    ...purgeMessages.en,
    ...sampleMessages.en,
    ...materialMessages.en,
    ...surveyMessages.en,
    ...siteMessages.en,
    ...lithologyMessages.en,
    ...environmentMessages.en,
    ...vulnerabilityMessages.en,
    ...conclusionMessages.en,
    ...inverstigatedEnvsMessages.en,
    ...programMessages.en,
    ...schemaMessages.en,
    ...reportsMessages.en,
    ...localesMessages.en,
    ...supervisionMessages.en,
  },
  fr: {
    $vuetify: locales.fr.$vuetify,
    ...purgeMessages.fr,
    ...sampleMessages.fr,
    ...siteMessages.fr,
    ...materialMessages.fr,
    ...surveyMessages.fr,
    ...lithologyMessages.fr,
    ...environmentMessages.fr,
    ...vulnerabilityMessages.fr,
    ...conclusionMessages.fr,
    ...inverstigatedEnvsMessages.fr,
    ...programMessages.fr,
    ...schemaMessages.fr,
    ...reportsMessages.fr,
    ...localesMessages.fr,
    ...supervisionMessages.fr,
  },
};

export default createI18n({
  legacy: false,
  locale: globalEnv.i18nLocale || "en",
  fallbackLocale: globalEnv.i18nFallbackLocale || "en",
  messages: messages,
  silentFallbackWarn: true,
});
